import { useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

import { ButtonV1, UploadCSV as UploadXslx } from "components";

import { useToaster } from "hooks";
import { getCall_v2, postCall_v2 } from "services";

import { success, error, JOMS_API_BASE_V1_URL } from "constants";

const BulkUpdateShipments = () => {
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [sampleFile, setSampleFile] = useState("");
  const fileUploadRef = useRef();
  const triggerToaster = useToaster();

  const fetchSampleFile = async () => {
    try {
      const { data } = await getCall_v2(
        `${JOMS_API_BASE_V1_URL}/v1/shipment/sample-excel-for-shipment-delivered`,
      );
      if (data?.isSuccess) {
        setSampleFile(data?.signedUrl);
      }
    } catch (err) {
      console.error("Error fetching shipments:", err);
    }
  };

  useEffect(() => {
    fetchSampleFile();
  }, []);

  /**
   * @description callback fn on file upload
   */
  const fileUploadCallback = async (file) => {
    setIsFileUploading(true);
    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await postCall_v2(
          `${JOMS_API_BASE_V1_URL}/v1/shipment/excel-upload-shipment-delivered`,
          formData,
        );
        if (res?.data) {
          triggerToaster(res?.data || "File uploaded successfully.", success);
        }
      } catch (err) {
        triggerToaster(
          err?.data?.errorMessage || `Error occurred, please try again`,
          error,
        );
      } finally {
        setIsFileUploading(false);
        fileUploadRef?.current?.resetFile();
      }
    }
  };

  const handleDownloadSampleFile = useCallback(async () => {
    try {
      window.open(sampleFile, "_blank");
    } catch (err) {
      triggerToaster(`Unable to download`, error);
    }
  }, [sampleFile]);

  return (
    <Box mb={8}>
      <Box mb={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <ButtonV1
          onClick={handleDownloadSampleFile}
          title={"Download Sample Template"}
          disabled={!sampleFile}
        />
      </Box>
      <UploadXslx
        fileCallBackFn={fileUploadCallback}
        allowedMaxSize={5}
        ref={fileUploadRef}
        isLoading={isFileUploading}
        fileType={["xls", "xlsx"]}
        instructionMsg="Upload an Excel file (.xls or .xlsx) with Invoice Number and Delivery Date (DD/MM/YYYY) to mark shipments as delivered. A status report will be generated after processing."
      />
    </Box>
  );
};

export default BulkUpdateShipments;
